import userRoles from "@constants/userRoles";

export const notLearnerRoles = [userRoles.ADMINISTRATOR, userRoles.INSTRUCTOR];
export const notAdminRoles = [userRoles.INSTRUCTOR, userRoles.LEARNER];
export const administrator = [userRoles.ADMINISTRATOR];
export const instructor = [userRoles.INSTRUCTOR];
export const learner = [userRoles.LEARNER];
